import ContactUsLink from "app/components/ContactUs/ContactUsLink";

const ContactUsItemWrap = ({ children }) => <ContactUsLink label="Drop Down">{children}</ContactUsLink>;

export default ContactUsItemWrap;
